<div [formGroup]="parentGroup" class="grid">
  <div class="form-group span-12">
    <label class="label" for="input-location">
      <ng-container i18n="@@shared.recipientOffer.input.location">Einsatzort</ng-container>
      <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
    </label>
    <ng-select #locationSelect
      (keydown.delete)="clearLocation()"
      [formControl]="locationControl"
      [items]="locations$ | async"
      [typeahead]="locationInput$"
      bindLabel="zipAndName"
      class="typeahead"
      i18n-placeholder="@@shared.recipientOffer.placeholder.location"
      i18n-typeToSearchText="@@shared.giverOffer.placeholder.plzTypeToSearchText"
      labelForId="input-location"
      notFoundText="Keine Treffer"
      placeholder="Einsatzort auswählen..."
      typeToSearchText="PLZ/Ortsnamen eingeben">
    </ng-select>
    @if (locationControl.invalid && (locationControl.touched || locationControl.dirty)) {
      <div
        class="validation error" i18n="@@shared.recipientOffer.error.location">Bitte wählen Sie Ihren Einsatzort
            aus.
        </div>
    }
  </div>

  <div class="form-group span-12">
    <label class="label" id="input-assistance-services">
      <ng-container i18n="@@shared.recipientOffer.input.assistanceServices">Ich suche Assistenz für</ng-container>
      <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
    </label>
    <div class="form-group span-12 information-text information-text--not-shure-terms"
      i18n="@@recipientOffer.informationText.notShureTerms">Sind sie nicht ganz sicher, was die untenstehenden
            Begriffe bedeuten oder welche Aufgaben damit verbunden sind? Kein Problem <a
                    [href]="linkToFilterDescription" target="_blank">lesen sie es hier nach.</a></div>
    @if (assistanceServicesControl.invalid && (assistanceServicesControl.touched || assistanceServicesControl.dirty)) {
      <div
        class="validation error fix-margin-assistance" i18n="@@shared.recipientOffer.error.assistanceServices">
            Bitte wählen Sie mindestens 1 Kategorie aus, um fortzufahren.
        </div>
    }
    <app-tag-selector
      (valueChange)="assistanceServicesControl.setValue($event); assistanceServicesControl.markAsDirty();"
      [selectableTags]="availableAssistanceServices$ | async"
      [value]="assistanceServicesControl.value"
      labelledby="input-assistance-services">
    </app-tag-selector>
  </div>

  <div class="form-group span-12">
    <label class="label" for="input-job-desc" i18n="@@shared.recipientOffer.input.jobDescription">Jobbeschreibung
            (optional, max 700 Zeichen)</label>
    <textarea class="textarea"
      formControlName="jobDescription"
      i18n-placeholder="@@shared.recipientOffer.placeholder.jobDescription"
      id="input-job-desc"
      maxlength="701"
    placeholder="Beschreiben Sie, bei was Sie Hilfe benötigen. Was ist Ihnen wichtig (z.B. Zuverlässlichkeit, Vertrauen, etc.)?"></textarea>
    @if (jobDescription.invalid && (jobDescription.touched || jobDescription.dirty)) {
      <div
        class="validation error" i18n="@@shared.recipientOffer.error.jobDescription">Sie haben mehr als die
            erlaubten 700 Zeichen eingegeben. Bitte reduzieren Sie die Anzahl Zeichen.
        </div>
    }
  </div>
</div>
